import { map as _map } from 'lodash-es';
import { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { makeStyles } from 'tss-react/mui';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import SelectField from '../forms/select-field';
import { eventWeatherCancellations } from '../../utils/events';
import type { EventFormValues } from './form';

const useStyles = makeStyles()((theme) => ({
  label: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: theme.spacing(0.5),
    fontSize: 16,
  },
}));

const EventFormWeatherCancellations = (props) => {
  const { classes } = useStyles();
  const { values: { eventType } } = useFormikContext<EventFormValues>();

  const options = useMemo(() => (
    _map(eventWeatherCancellations, ({ name }, value) => ({
      label: name,
      value,
    }))
  ), []);

  if (eventType === 'ONLINE_EVENT') {
    return null;
  }

  return (
    <SelectField
      name="weatherCancellation"
      label={(
        <span className={classes.label}>
          <WbSunnyIcon className={classes.icon} />
          Weather cancellation (optional)
        </span>
      )}
      options={options}
      placeholder="Choose One"
      {...props}
    />
  );
};

export default EventFormWeatherCancellations;
